import "./Spinner.css"

const Spinner = () => <div className="loader" />
export default Spinner
